export enum EventStatus {
  Upcoming = 1,
  Finished = 2,
  Canceled = 3,
};
